// src/pages/InviteRoleSelector.js

import React, { useState } from "react";
import { Card, Row, Col, Typography } from "antd";
import {
  UserOutlined,
  TeamOutlined,
  CrownOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";
import InviteEmployees from "./InviteEmployees";

const { Title, Text } = Typography;

const roles = [
  
  {
    key: 2,
    name: "Mentor",
    icon: <CrownOutlined />,
    color: "#52c41a",
  },
  {
    key: 3,
    name: "Manager",
    icon: <TeamOutlined />,
    color: "#faad14",
  },
];

const InviteRoleSelector = () => {
  const [selectedRole, setSelectedRole] = useState(null);

  return (
    <div>
      {!selectedRole ? (
        <Card title="Select Role to Invite" className="card-professional">
          <Row gutter={[24, 24]}>
            {roles.map((role) => (
              <Col xs={24} sm={12} md={12} key={role.key}>
                <Card
                  hoverable
                  style={{ borderLeft: `5px solid ${role.color}` }}
                  onClick={() => setSelectedRole(role.key)}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                    <div
                      style={{
                        background: `${role.color}20`,
                        color: role.color,
                        padding: 12,
                        borderRadius: "50%",
                        fontSize: 20,
                      }}
                    >
                      {role.icon}
                    </div>
                    <div>
                      <Title level={4}>{role.name}</Title>
                      <Text type="secondary">Invite a new {role.name}</Text>
                      <br />
                      <Text strong style={{ color: role.color }}>
                        Continue <ArrowRightOutlined />
                      </Text>
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </Card>
      ) : (
        <InviteEmployees selectedRole={selectedRole} goBack={() => setSelectedRole(null)} />
      )}
    </div>
  );
};

export default InviteRoleSelector;
